import React, { useContext, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";

import { MsalInstanceContext, VariablesContext } from "../../../auth/AppProvider";
import * as FormsComponent from "../index";
import { PencilIcon } from "@heroicons/react/24/outline";
import { verifyAddress, getCityByZipCode } from "../../../utils/requests/completions";
import Button from "../../Buttons/Button";

function AddressComponent({ t, question, form, formData, onDataChange, errors, schema }) {
    const variables = useContext(VariablesContext)
    const msalInstance = useContext(MsalInstanceContext);
    const [, setErrorShow] = useState(false);
    const [lockInfo, setLockInfo] = useState(false);
    const [errorsLoc, setErrorsLoc] = useState(null);
    const [formattedAddress, setFormattedAddress] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorCity, setErrorCity] = useState(false);
    const [errorZip, setErrorZip] = useState(false);

    const [setupCityZipCode, setSetupCityZipCode] = useState(false);
    const [lisCities, setLisCities] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);

    const [address, setAddress] = useState({
        Address1: "",
        Address2: "",
        Zipcode: "",
        City: "",
        Country: ""
    })

    useEffect(() => {
        setErrorCity(null)
        setErrorZip(null)
        if (errors && errors.length !== 0) {
            question.options.forEach(opt => {
                if (handleShowQuestion(opt.label)) {
                    var currQuestion = getQuestion(opt.value);
                    try {
                        schema.validateAt(currQuestion.name, formData[currQuestion.name]).catch(err => {
                            if (opt.label === "Zipcode") {
                                setErrorZip(err.errors[0])
                            } else if (opt.label === "City") {
                                setErrorCity(err.errors[0])
                            }
                        })
                    } catch (err) {
                        console.error("Validation error:", err);
                    }

                }
            })
        }
    }, [errors])

    useEffect(() => {
        if (handleShowQuestion("City") && handleShowQuestion("Zipcode") && !handleShowQuestion("Address1") && !handleShowQuestion("Address2")) {
            setSetupCityZipCode(true);
        }
    }, [form])

    useEffect(() => {
        if (!setupCityZipCode) {
            var locAdd = address;
            question.options.forEach(opt => {
                if (handleShowQuestion(opt.label)) {
                    var currQuestion = getQuestion(opt.value);
                    if (formData[currQuestion.name] !== "") {
                        locAdd[opt.label] = formData[currQuestion.name];
                    }
                }
            })
            setAddress(locAdd);
        }
    }, [formData])

    function handleCityZipCode(e) {
        setAddress({ ...address, Zipcode: e })
        setErrorsLoc(null);
        if (!e || e === "") {
            setErrorsLoc(t("Please fill zipcode"))
        } else if (e.length < 5) {
            setErrorsLoc(t("Zipcode min 5 digits"))
        } else if (e.length > 5) {
            setErrorsLoc(t("Zipcode max 5 digits"))
        } else {
            setLoading(true);
            var formDataLoc = { ...formData };
            var currQuestion = getQuestion(getOption("Zipcode")?.value);
            formDataLoc[currQuestion.name] = e;
            onDataChange(formDataLoc, currQuestion);
            getCityByZipCode(msalInstance, variables, e).then(data => {
                data = data.filter((item, index) => {
                    return data.findIndex(i => i.libelleAcheminement === item.libelleAcheminement) === index;
                }).sort((a, b) => a.libelleAcheminement.localeCompare(b.libelleAcheminement));
                if (data && data.length === 0) {
                    setErrorsLoc(t("No city found for zipcode"))
                } else if (data && data.length === 1) {
                    setAddress({ Zipcode: data[0].codePostal, City: data[0].libelleAcheminement });
                    var currQuestion = getQuestion(getOption("City")?.value);
                    formDataLoc[currQuestion.name] = data[0].libelleAcheminement;
                    onDataChange(formDataLoc, currQuestion);
                }
                if (data && data.length > 1) {
                    setShowDropdown(true);
                }
                setLisCities(data);
                setLoading(false);
            }).catch(err => {
                setErrorsLoc(t("An error occurred while retrieving cities. Please try again later."));
                setLoading(false);
            })
        }
    }

    function handleAddress() {
        setErrorsLoc(null);
        if (question.options.find(opt => handleShowQuestion(opt.label) && getQuestion(opt.value)?.required && address[opt.label] === "")) {
            setErrorsLoc(t("Please fill all required fields"))
        } else {
            setLockInfo(true);
            setFormattedAddress(false);
            setErrorShow(false);
            var query = address.Address1 + " " + address.Address2 + " " + address.Zipcode + " " + address.City;
            verifyAddress(msalInstance, variables, query).then(data => {
                var dataFormatted = {
                    Address1: data.numeroVoie + " " + data.libelleVoie,
                    Address2: "",
                    Zipcode: data.codePostal,
                    City: data.commune,
                    Country: address?.Country
                }
                setFormattedAddress(dataFormatted);
                question.options.forEach(opt => {
                    if (handleShowQuestion(opt.label)) {
                        if (dataFormatted[opt.value] !== "") {
                            var currQuestion = getQuestion(opt.value);
                            formData[currQuestion.name] = dataFormatted[opt.label];
                            onDataChange(formData, currQuestion);
                        }
                    }
                })

            }).catch(err => {
                setErrorsLoc(err);
                setLockInfo(false);
            })
        }
    }

    function getQuestion(id) {
        return form?.find(q => q.id === id);
    }

    function getOption(field) {
        return question?.options?.find(opt => opt.label === field);
    }

    function handleShowQuestion(field) {
        const optQuestion = getOption(field);
        return optQuestion?.hidden === false && getQuestion(optQuestion?.value) !== null && getQuestion(optQuestion?.value) !== undefined;
    }



    return question ? (setupCityZipCode ? <div>
        {errorsLoc ? <div className="col-span-full text-red-500 text-xs">{errorsLoc}</div> : null}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 align-end items-end mb-4">
            <div className="flex gap-6 align-center items-center">
                <div className="w-full">
                    <label htmlFor="postal-code" className={errorZip ? "font-medium text-[13px] text-red-600 flex items-center gap-1 mb-1.5" : "text-[13px] font-medium flex items-center gap-1 mb-1.5"} style={!errorZip ? { color: '#3a4250' } : {}}>
                        {getQuestion(getOption("Zipcode")?.value)?.label}{getQuestion(getOption("Zipcode")?.value)?.required ? <span className="text-red-500">*</span> : ""}
                    </label>
                    {errorZip ? <div className="text-xs text-red-500 mt-1">{errorZip}</div> : null}
                    <div style={{ position: "relative", maxWidth: 300 }}>
                        <FormsComponent.Input id="Zipcode" label={t("Zip code")} value={address.Zipcode} minLength={5} maxLength={5} onChange={handleCityZipCode} error={errorZip} />
                        {showDropdown && lisCities && lisCities.length > 0 ? (
                            <div
                                className="absolute w-full bg-white border z-10 overflow-y-auto scroller"
                                style={{ maxHeight: "120px" }}
                            >
                                {lisCities.map((city, idx) => (
                                    <div
                                        key={city.code || idx}
                                        className="hover:bg-gray-200 text-xs cursor-pointer p-2 border-b border-gray-300"
                                        onClick={() => {
                                            var currQuestion = getQuestion(getOption("City")?.value);
                                            formData[currQuestion.name] = city.libelleAcheminement;
                                            setAddress({ ...address, City: city.libelleAcheminement })
                                            onDataChange(formData, currQuestion);
                                            setShowDropdown(false);
                                        }}
                                    >
                                        {city.libelleAcheminement}
                                    </div>
                                ))}
                            </div>
                        ) : null}
                    </div>
                </div>
                {/* {loading ? <LoadingSpinner /> : <MagnifyingGlassIcon className="h-5 w-5 cursor-pointer" onClick={handleCityZipCode} />} */}
            </div>
            {address.City && <div className="w-full md:col-span-2">
                <label htmlFor="City" className={errorCity ? "font-medium text-[13px] text-red-600 flex items-center gap-1 mb-1.5" : "text-[13px] font-medium flex items-center gap-1 mb-1.5"} style={!errorCity ? { color: '#3a4250' } : {}}>
                    {getQuestion(getOption("City")?.value)?.label}{getQuestion(getOption("City")?.value)?.required ? <span className="text-red-500">*</span> : ""}
                </label>
                {errorCity ? <div className="text-xs text-red-500 mt-1">{errorCity}</div> : null}
                <FormsComponent.Input
                    id="city"
                    type="text"
                    readOnly={true}
                    value={address.City}
                    error={errorCity}
                />
            </div>}
        </div>
    </div> : <div>
        <div className="my-6 border-t border-b border-gray-900 py-6">
            {/* Formulaire de paiement */}
            <div >
                <form>
                    <div className="mb-6">
                        <div className="px-4 sm:px-0 flex justify-between">
                            <div><h2 className="text-base font-bold text-gray-900">{question.label}</h2>
                            </div>
                            {lockInfo && <div>
                                <PencilIcon className="h-6 w-6 text-gray-500 cursor-pointer" onClick={() => setLockInfo(false)} />
                            </div>}
                        </div>
                        {!lockInfo ?
                            <div className="grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-3 mt-4">
                                {errors ? <div className="col-span-full text-red-500">{JSON.stringify(errors)}</div> : null}
                                {handleShowQuestion("Address1") ? <div className="col-span-full">
                                    <label htmlFor="Address1" className="text-[13px] font-medium flex items-center gap-1 mb-1.5" style={{ color: '#3a4250' }}>
                                        {getQuestion(getOption("Address1")?.value)?.label}{getQuestion(getOption("Address1")?.value)?.required ? <span className="text-red-500">*</span> : ""}
                                    </label>
                                    <div>
                                        <FormsComponent.Input id="Address1" label={t("Address")} value={address.Address1} onChange={(e) => setAddress({ ...address, Address1: e })} />
                                    </div>
                                </div> : null}
                                {handleShowQuestion("Address2") ? <div className="col-span-full">
                                    <label htmlFor="Address2" className="text-[13px] font-medium flex items-center gap-1 mb-1.5" style={{ color: '#3a4250' }}>
                                        {getQuestion(getOption("Address2")?.value)?.label}{getQuestion(getOption("Address2")?.value)?.required ? <span className="text-red-500">*</span> : ""}
                                    </label>
                                    <div>
                                        <FormsComponent.Input id="adress2" label={t("Address line 2")} value={address.Address2} onChange={(e) => setAddress({ ...address, Address2: e })} />
                                    </div>
                                </div> : null}

                                {handleShowQuestion("City") ? <div className="col-span-1">
                                    <label htmlFor="City" className="text-[13px] font-medium flex items-center gap-1 mb-1.5" style={{ color: '#3a4250' }}>
                                        {getQuestion(getOption("City")?.value)?.label}{getQuestion(getOption("City")?.value)?.required ? <span className="text-red-500">*</span> : ""}
                                    </label>
                                    <div>
                                        <FormsComponent.Input id="City" label={t("City")} value={address.City} onChange={(e) => setAddress({ ...address, City: e })} />
                                    </div>
                                </div> : null}
                                {handleShowQuestion("Zipcode") ? <div className="col-span-1">
                                    <label htmlFor="postal-code" className="text-[13px] font-medium flex items-center gap-1 mb-1.5" style={{ color: '#3a4250' }}>
                                        {getQuestion(getOption("Zipcode")?.value)?.label}{getQuestion(getOption("Zipcode")?.value)?.required ? <span className="text-red-500">*</span> : ""}
                                    </label>
                                    <div>
                                        <FormsComponent.Input id="Zipcode" label={t("Zip code")} value={address.Zipcode} onChange={(e) => setAddress({ ...address, Zipcode: e })} />
                                    </div>
                                </div> : null}
                                {handleShowQuestion("Country") ? <div className="col-span-1">
                                    <label htmlFor="Country" className="text-[13px] font-medium flex items-center gap-1 mb-1.5" style={{ color: '#3a4250' }}>
                                        {getQuestion(getOption("Country")?.value)?.label}{getQuestion(getOption("Country")?.value)?.required ? <span className="text-red-500">*</span> : ""}
                                    </label>
                                    <div className="grid grid-cols-1">
                                        <select id="Country" label={t("Country")} className="block w-full text-sm bg-white border border-primary rounded-[11px] h-[46px] px-3.5 focus:outline-none transition-colors"
                                            onChange={(e) => {
                                                setAddress({ ...address, Country: e.target.value })
                                            }}
                                            value={address.Country}>
                                            <option value=""></option>
                                            {getQuestion(getOption("Country")?.value)?.options.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                        </select>
                                    </div>
                                </div> : null}
                            </div>
                            : <div>
                                <div>
                                    {formattedAddress.Address1}{" "}{formattedAddress.Address2}{" "}{formattedAddress.Zipcode}{" "}{formattedAddress.City}{" "}{getQuestion(getOption("Country")?.value)?.options.find(opt => opt.value === formattedAddress.Country)?.label}
                                </div>
                            </div>}
                    </div>
                    {!lockInfo && <div className="flex items-center justify-center">
                        <Button onClick={handleAddress}>{t("Vérifier l'adresse")}</Button>
                    </div>}
                </form>
                <div>

                </div>
            </div>

        </div>
    </div >) : null
}

export default withTranslation()(AddressComponent);